<template>
  <div class="search-wrap">
    <span>Поиск</span>
    <div class="input-addon">
      <input type="text" class="search" v-model="filter" @input="onFilterChange" ref="input">

      <svg width="28px" height="27px">
        <path
          d="M2.888 10.546c0,-3.217 1.727,-5.923 3.871,-7.475 4.205,-3.044 9.801,-1.831 12.682,2.15 2.15,2.97 2.289,7.331 0.137,10.309 -0.392,0.542 -0.538,0.787 -1.012,1.258 -2.566,2.549 -6.738,3.678 -10.106,2.042 -2.012,-0.977 -3.784,-2.399 -4.669,-4.528 -0.269,-0.645 -0.401,-0.922 -0.595,-1.675 -0.138,-0.536 -0.308,-1.489 -0.308,-2.081zm-1.314 -0.239c0,4.361 2.258,7.752 6.011,9.637 3.39,1.704 7.416,1.13 10.472,-0.917l8.033 7.973 1.91 -1.852 -7.942 -7.883c0.562,-1.01 1.011,-1.22 1.654,-2.825 1.364,-3.409 0.875,-7.964 -1.654,-10.672 -2.32,-2.485 -4.44,-3.733 -8.331,-3.733 -2.621,0 -5.358,1.258 -7.126,3.027 -1.82,1.819 -3.027,4.62 -3.027,7.245z"/>
      </svg>
    </div>
  </div>
</template>

<script>
  import _debounce from 'lodash/debounce'

  const onInputChanged = function () {
    this.$emit('change', this.filter)
  }

  export default {
    name: 'search',
    props: ['debounce'],
    data () {
      return {
        filter: ''
      }
    },
    computed: {
      onFilterChange () {
        return _debounce(onInputChanged, this.debounce).bind(this)
      }
    },
    mounted () {
      this.$refs.input.focus()
    }
  }
</script>

<style scoped lang="scss">
  .search-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    span {
      margin-right: 30px;
      font-weight: 300;
      @media screen and (max-width: 500px) {
        display: none;
      }
    }
    .input-addon {
      flex: 2;
      position: relative;
      input {
        width: 100%;
      }
      svg {
        fill: $light-blue;
        position: absolute;
        right: 10px;
        top: 10px;
        transform: scale(0.8);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search/Search.vue